import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { Flag } from '@ffx/common';

export function uniqueFlagKeyValidator(allFlags: Flag[], thisFlagId: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const keyExists = allFlags.some((flag) => flag.id !== thisFlagId && flag.key === control.value);
        return keyExists ? { duplicateFlagKey: control.value } : null;
    };
}

export function uniqueFlagNameValidator(allFlags: Flag[], thisFlagId: string): ValidatorFn {
    return (control: AbstractControl): ValidationErrors | null => {
        const nameExists = allFlags.some((flag) => flag.id !== thisFlagId && flag.name === control.value);
        return nameExists ? { duplicateFlagName: control.value } : null;
    };
}
